import React from 'react'

export default function UniversityCourt() {
    return (
        <div>UniversityCourt</div>
    )
}
